import { gql } from '@apollo/client';

export const CREATE_SCHEMA = gql`
  mutation CreateSchema($params: CreateSchemaInput) {
    createSchema(params: $params) {
      success
      message
      errors
      data {
        id
        schemaName
        description
        createdAt
        createdBy
        updatedAt
        updatedBy
      }
    }
  }
`;

export const UPDATE_SCHEMA = gql`
  mutation UpdateSchema($params: UpdateSchemaInput) {
    updateSchema(params: $params) {
      success
      message
      errors
      data {
        id
        schemaName
        description
        createdAt
        createdBy
        updatedAt
        updatedBy
      }
    }
  }
`;

export const DELETE_SCHEMA = gql`
  mutation DeleteSchema($params: DeleteSchemaInput) {
    deleteSchema(params: $params) {
      success
      message
      errors
    }
  }
`;
